import './index.scss';
import '../TopNavigation/index.scss';

import React, {useRef} from 'react';
import { Link, useLocation } from 'react-router-dom';
import { goBack } from '../../nonUIFuncs';
import { useSelector } from 'react-redux';
import { selectReduxSlice } from '../../../Store/store';

const NavigationButton = ({ animateMenu, pathname, icon, search, title, external = false }) => {
  const reduxState = useSelector(selectReduxSlice);
  const reduxStateRef = useRef(reduxState);
  reduxStateRef.current = reduxState;
  let vmin =
    reduxStateRef.current.height > reduxStateRef.current.width
      ? reduxStateRef.current.width
      : reduxStateRef.current.height;



  let fontSize = vmin * 0.034;
  if (fontSize < 20) {
    fontSize = 20;
  } else if (fontSize > 50) {
    fontSize = 50;
  }

  if (title.length > 20) {
    fontSize = fontSize * 0.8;
  }



  if (external) {
    return (
      <a href={pathname}>
        <div className="navmenu_button hovercursor">
          <div className={`navmenu_button_container_${icon}`} />
          <div className="navmenu_button_text" style={{ fontSize: fontSize }}>
            {title}
          </div>
        </div>
      </a>
    );
  } else {
    return (
      <Link
        onClick={animateMenu}
        className="navmenu_button hovercursor"
        to={{
          pathname: pathname,
          search: search,
        }}>
        <div className={`navmenu_button_container_${icon}`} />
        <div className="navmenu_button_text" style={{ fontSize: fontSize }}>
          {title}
        </div>
      </Link>
    );
  }

};

const NavigationMenu = ({animateMenu, config}) => {
  const Location = useLocation();
  const reduxState = useSelector(selectReduxSlice);
  return (
    <div id="navmenu_fade" className="navmenu_fullscreen" onClick={animateMenu}>
      <div id="navmenu_slide" className="navmenu_dropdownmenu">
        <div className="navmenu_safearea">
          <NavigationButton
            animateMenu={animateMenu} pathname="/" icon="home" search="" title="Home" />
          <NavigationButton
            animateMenu={animateMenu}
            pathname={goBack(Location).pathname}
            icon="back"
            search={goBack(Location).search}
            title="Back"
          />
          <NavigationButton
            animateMenu={animateMenu}
            pathname="/dictionary"
            icon="menu"
            search=""
            title="Dictionary"
          />
          {reduxState.historyData !== undefined ? (
            <NavigationButton
              animateMenu={animateMenu}
              pathname="/timeline"
              icon="timeline"
              search=""
              title="Timeline Game"
            />
          ) : null}
          <NavigationButton
            animateMenu={animateMenu}
            pathname="/endless-mode"
            icon="endless"
            search=""
            title="Endless"
          />
          {config.Credits !== undefined ? (
            <NavigationButton
              animateMenu={animateMenu}
              pathname="/credits"
              icon="credits"
              search=""
              title="Credits"
            />
          ) : null}
          {config.ShowStorybookCorner ? (
            <NavigationButton
              animateMenu={animateMenu}
              pathname="/story-book-corner"
              icon="storybook"
              search=""
              title="Story Book Corner"
            />
          ) : null}
          {config.ShowLinkButton ? (
            <NavigationButton
              external={true}
              pathname={`${config.Link}`}
              icon="preschool"
              title="Preschool Activity Center"
            />
          ) : null}

        </div>
      </div>
    </div>
  );
};

export default NavigationMenu;